import React from 'react';
import styled from 'styled-components';

const Container = styled.span`
  .checkbox-container {
    display: flex;
    justify-content: center;
    align-content: center;

    width: 25px;
    height: 25px;

    position: relative;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    height: 25px;
    width: 25px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px #ccc solid;
    border-radius: 50%;
    transition: all 0.5s ease-in-out;
  }

  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    background-color: #0073aa;
    transition: all 0.5s ease-in-out;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-container .checkmark:after {
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;

export const ExtensionCheckbox: React.FC<React.InputHTMLAttributes<never>> = (props) => (
  <Container>
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label className="checkbox-container">
      <input {...props} type="checkbox" />
      <span className="checkmark" />
    </label>
  </Container>
);
